import React from 'react'
import { Container } from 'semantic-ui-react';
import { Grid } from 'semantic-ui-react';
import { useSelector} from 'react-redux';
import {db} from '../../../firebase'
import { elementTypeAcceptingRef } from '@mui/utils';
const Facturacionempresa = (props) => {
  //console.log(props)
  const userUid = useSelector(store => store.usuario.user.uid);
  // const [allOrders,setAllOrders] = React.useState([])
  // const [userOrders,setUserOrders] = React.useState([])

  React.useEffect(()=>{
    

  },[])




  return (
    <Container className='dashcontent'>
        <Grid celled='internally'  id='mi-cuentaContent'>
        <div><h2> Detalles mis compras</h2></div>
        <Grid.Row> 
        <table className="table">
                            <thead>
                            <tr>
                            <th scope="col">Numero de Orden</th>
                            <th scope="col">Fecha de Compra</th>
                            <th scope="col">Total</th>
                            <th scope="col">Status</th>
                            <th scope="col">Documento</th>
                            <th scope="col">Acción</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                              props.companyBilling?(<>
                               {props.companyBilling.map((element) => (
                                <tr key={element.id}>
                                <td >{element.buyOrder}</td>
                                <td >{element.transactionDate}</td>
                                <td >${element.amount}</td>
                                <td >{element.status}</td>
                                <td ><button>Download</button></td>
                                <td ><button>Ver</button></td>
                                </tr>
                                ))                          
                            }

                              </>):(<></>)
                            }


                           
                            </tbody>
                            </table>
        </Grid.Row> 
        </Grid>
    </Container>
  )
}

export default Facturacionempresa